import React from 'react'

type PolicyContext = {
  policy: any
}

export default React.createContext<PolicyContext>({ policy: null })
